import { Mail, MessageSquareText, Zap, ShieldCheck, Percent } from "lucide-react";

const ITEMS = [
  { icon: Mail, label: "Email & PEC" },
  { icon: MessageSquareText, label: "WhatsApp integrato" },
  { icon: Zap, label: "Workflow automatici" },
  { icon: ShieldCheck, label: "Accesso sicuro" },
  { icon: Percent, label: "Programma Partner" },
];

export const TrustStrip = () => {
  return (
    <section data-testid="trust-strip" className="relative z-10 -mt-10 section-lavender border-y border-border lg:-mt-16">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-x-8 gap-y-4 px-4 py-5 sm:px-6 lg:px-8">
        {ITEMS.map(({ icon: Icon, label }) => (
          <div key={label} className="inline-flex items-center gap-2 text-sm font-semibold text-foreground/80">
            <Icon className="h-4 w-4 text-primary" strokeWidth={2} />
            {label}
          </div>
        ))}
      </div>
    </section>
  );
};
